export default __webpack_public_path__ + "static/media/lsd-bg-3.82043857.webp";